import { Component, OnInit } from '@angular/core';
import {ModalController} from '@ionic/angular';

@Component({
  selector: 'app-delete-confirm',
  templateUrl: './delete-confirm.page.html',
  styleUrls: ['./delete-confirm.page.scss'],
})
export class DeleteConfirmPage implements OnInit {

  constructor(public modalController: ModalController) { }

  ngOnInit() {
  }

  cancel() {
    this.modalController.dismiss(false);
  }

  delete() {
    this.modalController.dismiss(true);
  }

}
